// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Hilfreich?',
  helpful: 'Hilfreich',
  not_helpful: 'Nicht hilfreich',
  thanks: 'Danke, notiert.',
};
